<template>
    <div>
        <div class="content-box">
            <p>以下工单可下载素材为空，请剔除后下载</p>
            <div class="maxHeight">
                <div v-for="(item,index) in list" :key="index">工单ID：{{ item.order_id }}，项目名称：{{item.project_name}}</div>
            </div>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="default" @click="hideModal" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="submitModal" :loading="formLoading" class="action-btn ml20">剔除</el-button>
        </p>
    </div>
</template>

<!-- 工单管理 通过素材弹框-->
<script>

export default {
    name: "filterNullDownModal",
    props:['cbs', 'list'],
    data(){
        return {
            formLoading:false,
            formItem:{
                group:'',
            },
            rules:{

            },
        }
    },
    mounted(){
    },
    methods:{
        submitModal(){
            this.cbs.onSubmit()
        },
        hideModal(){
            this.$emit('close');
        },
    }
}
</script>

<style scoped>
.maxHeight{
    max-height:calc(100vh - 300px);
    overflow-y: auto;
}
</style>
